import { ArrowForward } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import { isValidElement } from "react";

interface IEditableCardRow {
  title: string;
  titleContext: any;
  onClick(): any;
  type?: "edit" | "add" | "details";
  auxText?: string;
  auxIcon?: any;
  colorButton?: string;
}

function typeCard(
  type: "edit" | "add" | "details" | undefined,
  auxText: string | undefined
) {
  if (auxText) {
    return auxText;
  }
  if (type === "add") {
    return "Adicionar";
  } else if (type === "details") {
    return "Detalhes";
  } else {
    return "Editar";
  }
}

export function EditableCardRow({
  title,
  titleContext,
  onClick,
  type,
  colorButton,
  auxText,
  auxIcon,
}: IEditableCardRow) {
  return (
    <Button
      fullWidth
      sx={{
        textTransform: "none",
        justifyContent: "flex-start",
        textAlign: "left",
        py: { xs: 1.25, sm: 2.5, md: 3 },
        px: { xs: 1.5, sm: 2.5, md: 3 },
        pl: { xs: 1.5, sm: 2.5, md: 5 },
        borderRadius: 0,
        color: "inherit",
        "&:hover": { bgcolor: "action.hover" },
      }}
      onClick={onClick}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        width="100%"
        alignItems={{ xs: "flex-start", sm: "start" }}
        spacing={{ xs: 0.35, sm: 0 }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            width: { xs: "100%", sm: "20%" },
            textAlign: "left",
            wordBreak: "break-word",
            fontWeight: 500,
            fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          color="text.primary"
          sx={{
            width: { xs: "100%", sm: "60%" },
            textAlign: "left",
            fontWeight: 600,
            pl: { xs: 0, sm: 1 },
            wordBreak: "break-word",
            fontSize: { xs: "0.875rem", sm: "0.9375rem", md: "1rem" },
          }}
        >
          {isValidElement(titleContext) ? titleContext : titleContext}
        </Typography>
        <Typography
          component="span"
          variant="body2"
          color={colorButton || "primary.main"}
          sx={{
            width: { xs: "100%", sm: "20%" },
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
            gap: 0.75,
            mt: { xs: 0.25, sm: 0 },
            fontWeight: 600,
            fontSize: { xs: "0.8125rem", sm: "0.875rem" },
          }}
        >
          {typeCard(type, auxText)}
          {auxIcon ? auxIcon : <ArrowForward sx={{ fontSize: { xs: 16, sm: 18 } }} />}
        </Typography>
      </Stack>
    </Button>
  );
}
